export default "__VITE_ASSET__BP3J0u66__"